module.exports = __webpack_public_path__ + "img/illustration-pc.7f939bb9.svg";